import { Component, OnInit } from '@angular/core';
import { ActivationStart, Router } from '@angular/router';
import { AuthStoreService, ContentStoreService } from '@motivforce/mx-library-angular';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';
import { SiteSettings } from 'src/app/core/model/site-settings';
import { environment } from 'src/environments/environment';

@UntilDestroy()
@Component({
  selector: 'app-full-layout',
  templateUrl: './full-layout.component.html',
  styleUrls: ['./full-layout.component.scss'],
})
export class FullLayoutComponent implements OnInit {
  headerFixed = environment.headerFixed;

  hideHeaderFooter = false;
  isLanding = false;
  hideHeaderMenu = false;

  authenticatedUser$ = this.authStore.authenticatedUser$.pipe(untilDestroyed(this));

  isOpen = true;
  displayUserlane = false;

  constructor(private router: Router, private authStore: AuthStoreService, private contentStore: ContentStoreService) {}

  ngOnInit(): void {
    this.router.events.pipe(filter((event) => event instanceof ActivationStart)).subscribe((event: any) => {
      this.hideHeaderFooter = event.snapshot?.data?.hideHeaderFooter;
      this.isLanding = event.snapshot?.data?.isLanding;
      this.hideHeaderMenu = event.snapshot?.data?.hideHeaderMenu;
    });

    this.contentStore.siteSettings$.pipe(filter(Boolean), untilDestroyed(this)).subscribe((settings) => {
      const { siteSettings } = settings as SiteSettings;
      if (siteSettings.displayUserlane !== null && siteSettings.displayUserlane !== undefined) {
        this.displayUserlane = siteSettings.displayUserlane;
      }
    });
  }
}
